import { Link } from 'react-router-dom'

export function QuoteRefreshNotice() {
  return <section className="notice-panel" role="status">
    <h2>Start a new quote.</h2>
    <p>Our U.S. warehouse has changed since this quote was created. Start a new order to get current shipping rates and the correct forwarding address. You cannot pay this old quote.</p>
    <Link className="button button--primary" to="/inbounds/new">Start a new order</Link>
  </section>
}
